import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class UtilityService {

  constructor() { }

  addZeroTimeStamp(localeDateTimeObj: Date) {
    return new Date(localeDateTimeObj.getTime() - (localeDateTimeObj.getTimezoneOffset() * 60000)).toISOString();
  }
  
  localTimeStampToUTCStart(localeDateTimeObjStart: Date) {
    // let conversionDate = new Date(localeDateTimeObj.getTime() + (localeDateTimeObj.getTimezoneOffset() * 60000)).toISOString();
    let conversionDateStart = new Date(localeDateTimeObjStart).toISOString();
    return conversionDateStart;
  }
 
  localTimeStampToUTCEnd(localeDateTimeObjEnd: Date) {
    let addingEndHours = localeDateTimeObjEnd.getTime() + (((60 * 23) + 59) * 60000);
    let addingEndHoursUTC = new Date(addingEndHours).toISOString();
    return addingEndHoursUTC;
  }
}
